export default "__VITE_ASSET__4ee01831__"